import React from 'react';
import { Trans } from 'react-i18next';
import { Box, Text } from '@wix/design-system';

export const MobileChargeDetail: React.FC<{
  transkey: string;
  keyValues: Record<string, any>;
  // English fallback rendered when the translation key is missing —
  // see ChargeDetail.tsx for details.
  defaultLabel?: string;
  defaultValue?: string;
}> = ({ transkey, keyValues, defaultLabel, defaultValue }) => {
  return (
    <Text dataHook={`charge-details__${transkey}`} secondary>
      <Box marginBottom="SP1" display="block">
        <Trans
          i18nKey={`charge-locator.results-page.field-name.${transkey}`}
          values={keyValues}
        >
          {defaultLabel ?? 'charge-locator.results-page.'}
          <Text tagName="div" secondary={false} weight="normal">
            {defaultValue ?? `field-name.${transkey}`}
          </Text>
        </Trans>
      </Box>
    </Text>
  );
};
